import { Link } from "react-router-dom";
import "./ServicesCTA.css";

function ServicesCTA({ eyebrow, title, text, ctaLabel, ctaHref, note }) {
  return (
    <section className="services-cta-container fade-in-up">
      <div className="services-cta-inner hover-lift">
        <div className="services-cta-content">
          
          <div className="services-cta-copy">
            {eyebrow && (
              <span className="services-cta-eyebrow">{eyebrow}</span>
            )}
            {title && <h2>{title}</h2>}
            {text && <p>{text}</p>}
          </div>

          {ctaLabel && (
            <div className="services-cta-actions">
              <Link to={ctaHref || "/kontakt"} className="btn services-cta-btn">
                {ctaLabel}
              </Link>

              {note && (
                <span className="services-cta-note">
                  {note}
                </span>
              )}
            </div>
          )}

        </div>
      </div>
    </section>
  );
}

export default ServicesCTA;
